export const NAME_REQUEST_BILLING = [
    '',
    'Pendiente',
    'Servicios Autorizados',
    'Orden de Compra Autorizada',
    'Orden de Compra Asignada',
    'Solicitud Rechazada'
]
export const LABEL_STATUS_REQUEST = [
    '',
    'btn-info',
    'btn-secondary',
    'btn-primary',
    'btn-success',
    'btn-danger'
]


// WEBPACK FOOTER //
// ./frontEnd/billing/constants/constants.js